import React, { useEffect, useState, useRef, useContext } from "react";
import { useParams } from "react-router-dom";
import UnknownProfileImage from "../../assets/profile.jpg";
import {
  getActorReels,
  getActorsById,
  getCrewDetails,
  getCrewReels,
  getUserDetails,
} from "../../api/axios";
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import YoutubeCard from "./YoutubeCard";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Avatar,
  Grid,
  Button,
  CircularProgress,
  Divider,
  Rating,
} from "@mui/material";
import { AuthContext } from "../../context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";

const ethnicities = [
  {
    value: "black",
    label: "African American",
  },
  {
    value: "asian",
    label: "Asian",
  },
  {
    value: "latino/hispanic",
    label: "Latino Hispanic",
  },
  {
    value: "white/caucasian",
    label: "European American",
  },
  {
    value: "middle_eastern",
    label: "Middle Eastern",
  },
  {
    value: "native_american",
    label: "Native American",
  },
  {
    value: "pacific_islander",
    label: "Pacific Islander",
  },
  {
    value: "indian/south_asian",
    label: "Indian South Asian",
  },
  {
    value: "other",
    label: "Other",
  },
];

// const FloatingNav = ({ sections }) => {
//   return (
//     <Box
//       sx={{
//         position: "fixed",
//         top: 130,
//         right: 50,
//         backgroundColor: "#ffffff",
//         boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
//         borderRadius: "8px",
//         padding: "16px",
//         zIndex: 1000,
//         width: "200px",
//         border: "1px solid #e0e0e0",
//       }}
//     >
//       <Typography
//         variant="h6"
//         sx={{
//           fontWeight: "bold",
//           marginBottom: "12px",
//           color: "#333333",
//           fontSize: "18px",
//         }}
//       >
//         Profile
//       </Typography>
//       {sections.map((section) => (
//         <Button
//           key={section.id}
//           onClick={() => {
//             document.getElementById(section.id).scrollIntoView({
//               behavior: "smooth",
//             });
//           }}
//           sx={{
//             display: "block",
//             textAlign: "left",
//             width: "100%",
//             padding: "2px 12px",
//             margin: "0px",
//             borderRadius: "4px",
//             color: "#555555",
//             fontSize: "14px",
//             textTransform: "none",
//             "&:hover": {
//               backgroundColor: "#f0f0f0 !important" ,
//               color: "#000000 !important",
//             },
//           }}
//         >
//           {section.label}
//         </Button>
//       ))}
//     </Box>
//   );
// };

const ActorDetails = () => {
  const { id } = useParams();
  const { role } = useParams();
  const [actor, setActor] = useState({});
  // console.log('actor: ', actor);
  const [loading, setLoading] = useState(true);
  const [visibleVideos, setVisibleVideos] = useState(4);

  const { role: userRole, token, userId } = useContext(AuthContext);

  const getEthnicityLabel = (value) => {
    const ethnicity = ethnicities.find((e) => e.value === value);
    return ethnicity ? ethnicity.label : "Unknown"; // Return label if found, otherwise "Unknown"
  };

  const nameRef = useRef(null);
  const videoRef = useRef(null);

  // console.log('actor from details role', role);

  const GetActorById = async (id) => {
    nprogress.start();
    try {
      let res;
      if (role === "actor") {
        res = await getActorsById(id);
      } else {
        res = await getCrewDetails(id);
      }

      if (res.success) {
        setActor(res.user);
      }
      // const res = await getActorsById(id);
      // if (res.success) {
      //   setActor(res.user);
      // }
    } catch (error) {
      // console.log('Error fetching actor:', error);
    } finally {
      nprogress.done();
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      GetActorById(id);
      GetActorReels(id);
    }
  }, [id]);

  const handleLoadMore = () => {
    setVisibleVideos((prevCount) => prevCount + 4);
  };

  const [videoLinks, setVideoLinks] = useState({
    demoReel: "",
    slate: "",
    ugcDemoReel: "",
  });

  //GET actor reels
  const GetActorReels = async (id) => {
    try {
      if (role === "actor") {
        const res = await getActorReels(id);
        // console.log('Actor Reels', JSON.stringify(res, null, 2));
        if (res?.status) {
          setVideoLinks({
            demoReel: res?.result?.demoReel,
            slate: res?.result?.slate,
            ugcDemoReel: res?.result?.ugcDemoReal,
          });
        }
      } else if (role === "crew") {
        const res = await getCrewReels(id);
        // console.log('Actor Reels', JSON.stringify(res, null, 2));
        if (res.status) {
          setVideoLinks({
            demoReel: res.result.demoReel,
            slate: res.result.slate,
            ugcDemoReel: res.result.ugcDemoReal,
          });
        }
      }
    } catch (error) {
      // console.log('error fetching reels', error);
    }
  };

  const getImagesArray = () => {
    try {
      // Case 1: images is already an array
      if (
        actor?.registerResult?.images &&
        Array.isArray(actor.registerResult.images) &&
        actor.registerResult.images.length > 0
      ) {
        return actor.registerResult.images;
      }

      // Case 2: images is a JSON string
      if (
        actor?.registerResult?.images &&
        typeof actor.registerResult.images === "string"
      ) {
        try {
          const parsed = JSON.parse(actor.registerResult.images);
          if (Array.isArray(parsed) && parsed.length > 0) {
            return parsed;
          }
        } catch (e) {
          console.error("Error parsing images JSON", e);
        }
      }

      // Case 3: Single image URL as string
      if (
        actor?.registerResult?.images &&
        typeof actor.registerResult.images === "string" &&
        !actor.registerResult.images.startsWith("[")
      ) {
        return [actor.registerResult.images];
      }

      // Case 4: Fallback to imageURL or default
      const fallbackImage =
        actor?.registerResult?.imageURL ||
        actor?.result?.imageURL ||
        UnknownProfileImage;
      return [fallbackImage];
    } catch (error) {
      console.error("Error processing images", error);
      return [UnknownProfileImage];
    }
  };

  // Use this array instead of directly using actor?.registerResult?.images
  const imagesArray = getImagesArray();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  const sections = [
    { id: "name", label: "Name" },
    { id: "interested-in", label: "Interested In" },
    { id: "age", label: "Age" },
    { id: "ethnicity", label: "Ethnicity" },
    { id: "gender", label: "Gender" },
    { id: "hair-color", label: "Hair Color" },
    { id: "eye-color", label: "Eye Color" },
    { id: "talents", label: "Talents" },
    { id: "about", label: "About" },
    { id: "hobbies", label: "Hobbies" },
    { id: "demo-reels", label: "Demo Reels" },
  ];

  let category = actor?.result?.category || [];
  if (category) {
    if (typeof category === "string") {
      category = category.split(",").map((item) => item.trim());
    }
  }

  console.log("userRole: ", userRole);

  return (
    <Box
      sx={{
        color: "#6e0506",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "calc(100vh - 1px)",
      }}
    >
      {/* <Box sx={{ color: '#6e0506', maxWidth: 900, mx: 'auto', my: 4, p: 2 }}> */}
      {/* <FloatingNav sections={sections} /> */}
      {/* <Card
        sx={{
          color: '#6e0506',
          display: 'flex',
          flexDirection: 'column',
          p: 3,
        }}
      > */}
      <Card
        sx={{
          color: "#6e0506",
          display: "flex",
          flexDirection: "column",
          p: { xs: 2, sm: 3, md: 4, lg: 5 },

          width: { xs: "80%", sm: "95%", md: "80%", lg: "75%" },

          borderRadius: "16px",
          boxShadow: "0 20px 50px rgba(110, 5, 6, 0.25)",
        }}
      >
        <Grid
          container
          sx={{
            display: "flex",
            justifyContent: "start",
            gap: 2,
          }}
        >
          {/* <Grid container spacing={3}> */}
          {/* Profile Image */}
          {/* <Grid item xs={12} md={4} display='flex' justifyContent='center'>
            <Slider
              dots={true}
              infinite={imagesArray.length > 1}
              speed={500}
              slidesToShow={1}
              slidesToScroll={1}
              arrows={true}
              autoplay={imagesArray.length > 1}
              autoplaySpeed={3000}
              style={{
                width: 180,
                height: 180,
                overflow: 'hidden',
                borderRadius: '50%',
              }}
            >
              {imagesArray?.map((img, idx) => (
                <div key={idx} style={{ width: '100%', height: '100%' }}>
                  <img
                    src={img || UnknownProfileImage}
                    style={{
                      objectFit: 'cover',
                      height: '180px',
                      width: '180px',
                      borderRadius: '50%',
                    }}
                    alt={actor?.registerResult?.firstName || 'Unknown'}
                    onError={(e) => {
                      e.target.src = UnknownProfileImage;
                    }}
                  />
                </div>
              ))}
            </Slider>
          </Grid> */}

          {/* <Grid item xs={12} md={4} display='flex' justifyContent='center'> */}
          <Grid
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              alignItems: "center",
            }}
          >
            <Avatar
              src={actor.registerResult?.imageURL}
              alt="Actor"
              sx={{
                width: { xs: 100, sm: 140, md: 180 },
                height: { xs: 100, sm: 140, md: 180 },
              }}
            />
          </Grid>
          {/* Actor Details */}
          <Grid item id="profile">
            <Typography
              variant="h4"
              id="name"
              sx={{
                fontSize: {
                  xs: "22px",
                  sm: "24px",
                  md: "32px",
                },
              }}
            >
              {actor?.registerResult?.firstName?.charAt(0).toUpperCase() +
                actor?.registerResult?.firstName?.slice(1)}{" "}
              {actor?.registerResult?.lastName?.charAt(0).toUpperCase() +
                actor?.registerResult?.lastName?.slice(1)}
            </Typography>

            <Box display="flex" alignItems="center" gap={1} mt={1}>
              {role === "actor" && (
                <Typography variant="body1">
                  <FontAwesomeIcon
                    icon={faStar}
                    className="star"
                    style={{ color: "#6E0506" }}
                  />
                  {actor?.result?.rate || actor?.registerResult?.rate || 0}
                </Typography>
              )}
            </Box>

            <Typography variant="body2" color="text.secondary">
              Profile ID: {actor?.registerResult?.id}
            </Typography>

            <Divider sx={{ my: 2 }} />

            {/* Additional Info */}
            {actor?.result?.interestedIn && role !== "crew" && (
              <Typography id="interested-in">
                <strong>Interested in:</strong>{" "}
                {actor?.result.interestedIn ||
                  actor?.registerResult.interestedIn ||
                  " "}
              </Typography>
            )}
            {actor?.result?.age || actor?.registerResult?.age ? (
              <Typography id="age">
                <strong>Age:</strong>{" "}
                {actor?.result?.age || actor?.registerResult?.age || " "} y.o.
              </Typography>
            ) : null}

            <Typography id="category">
              <strong>Job Titles:</strong>{" "}
              {category && category.length > 0 ? category.join(", ") : "N/A"}
            </Typography>

            <Typography id="location">
              <strong>Location:</strong>{" "}
              {actor?.result?.location ? actor?.result?.location : "N/A"}
            </Typography>

            <Typography id="gender">
              <strong>Gender:</strong>{" "}
              {actor?.result?.gender?.charAt(0).toUpperCase() +
                actor?.result?.gender?.slice(1) ||
                actor?.registerResult?.gender?.charAt(0).toUpperCase() +
                  actor?.registerResult?.gender?.slice(1) ||
                " "}
            </Typography>
            {(actor?.result?.hairColor || actor?.registerResult?.hairColor) &&
              role !== "crew" && (
                <Typography id="hair-color">
                  <strong>Hair Color:</strong>{" "}
                  {actor?.result?.hairColor ||
                    actor?.registerResult?.hairColor ||
                    " "}
                </Typography>
              )}
            {(actor?.result?.eyeColor || actor?.registerResult?.eyeColor) &&
              role !== "crew" && (
                <Typography id="eye-color">
                  <strong>Eye Color:</strong>{" "}
                  {actor?.result?.eyeColor ||
                    actor?.registerResult?.eyeColor ||
                    " "}
                </Typography>
              )}
            {actor?.result?.talents && (
              <Typography id="talents">
                <strong>Talents:</strong>{" "}
                {actor?.result?.talents ||
                  actor?.registerResult?.talents ||
                  " "}
              </Typography>
            )}
            {actor?.result?.about && (
              <Typography id="about">
                <strong>About:</strong>{" "}
                {actor?.result.about || actor?.registerResult.about || " "}
              </Typography>
            )}
            {actor?.result?.hobbies && (
              <Typography id="hobbies">
                <strong>Hobbies:</strong>{" "}
                {actor?.result.hobbies || actor?.registerResult.hobbies || " "}
              </Typography>
            )}
          </Grid>
        </Grid>

        <Divider sx={{ my: 1 }} />
        {(userRole === "director" || userRole === "producer") && (
          <Box id="demo-reels">
            <Typography
              sx={{
                color: "#6e0506",
                mb: 0,
                fontSize: {
                  xs: "22px",
                  sm: "24px",
                  md: "32px",
                },
              }}
              variant="h5"
              id="demo-reels"
              gutterBottom
            >
              Demo Reels
            </Typography>
            {Object.values(videoLinks).some((value) => value) ? (
              <Grid
                sx={{
                  color: "#6e0506",
                  mb: 0,
                  fontSize: {
                    xs: "18px",
                    sm: "24px",
                    md: "26px",
                  },
                }}
                container
                spacing={2}
              >
                {Object.entries(videoLinks).map(([key, value]) => (
                  <Grid item xs={12} sm={6} key={key}>
                    <YoutubeCard videoLink={value} />
                    <div className="video-label">Demo Reel</div>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Typography
                sx={{
                  color: "#6e0506",
                  mb: 0,
                  fontSize: {
                    xs: "14px",
                    sm: "20px",
                    md: "22px",
                  },
                }}
                variant="h6"
                gutterBottom
              >
                No any reels added.
              </Typography>
            )}

            {/* Load More Button */}
            {visibleVideos < videoLinks.length && (
              <Box display="flex" justifyContent="center" mt={2}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleLoadMore}
                >
                  Load More
                </Button>
              </Box>
            )}
          </Box>
        )}
      </Card>
    </Box>
  );
};

export default ActorDetails;
